import { useState, useEffect, forwardRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Slide,
  Typography,
} from "@mui/material";
import { useMenu } from "../../context/MenuOpenContext";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { GetSensitiveChangeByIdService } from "../../services/SensitiveData/GetSensitiveChangeByIdService";
import { getToken } from "../../utils/GetToken";
import ReviewSensitiveChange from "../sensitive-data-changes-components/ReviewSensitiveChange";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ReviewSensitiveChangesLayout({
  changeId,
  setClickReview,
}) {
  const [openDialog, setOpenDialog] = useState(true);

  const [changeDetails, setChangeDetails] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isOpen } = useMenu();

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpenDialog(false);
      setClickReview(false);
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    getChangeDetails();
  }, []);

  // useEffect(() => {
  //   documentStateApproved && handleDocApproved();
  // }, [documentStateApproved])

  const getChangeDetails = async () => {
    try {
      const token = await getToken();
      if (token) {
        const data = await GetSensitiveChangeByIdService(token, changeId);
        setChangeDetails(data);
        // setLoading(false);
        console.log(data);
      }
    } catch (error) {
      // setLoading(false);
      console.log(error);
    } finally {
    }
  };

  return (
    <>
      {changeDetails !== null && (
        <Dialog
          disableEscapeKeyDown
          open={openDialog}
          TransitionComponent={Transition}
          onClose={handleCloseDialog}
        >
          <DialogTitle>{changeDetails && changeDetails.description}</DialogTitle>
          <DialogContent>
            {changeDetails !== null && (
              <ReviewSensitiveChange
                changeDetails={changeDetails}
                handleClose={handleClose}
              />
            )}
          </DialogContent>
          <DialogActions sx={{ textAlign: "center" }}>
            <Button
              onClick={() => {
                handleCloseDialog();
              }}
            >
              {t("cancel.button")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
